<script>
  import { page } from '$app/stores';
  import { api } from '$lib/utils/api';
  import { createMutation } from '@tanstack/svelte-query';
  import { untrack } from 'svelte';

  let currentPath = $state(null);

  const logPageViewMutation = createMutation({
    mutationKey: ['logPageView'],
    mutationFn: async (logRecord) =>
      await api().post('v2/logPageView', logRecord),
  });

  function logPageView(entity, entityId, log) {
    $logPageViewMutation.mutate({
      entity,
      entityId,
      log,
    });
  }

  $effect(() => {
    const pathname = $page.url.pathname;
    if (currentPath === pathname) return;
    currentPath = pathname;

    const { clientId, companyId, reportId } = $page.params;

    untrack(() => {
      if (clientId) {
        logPageView(
          'CLIENT',
          Number.parseInt(clientId, 10),
          pathname.toUpperCase(),
        );
      } else if (reportId) {
        logPageView(
          'REPORT',
          Number.parseInt(reportId, 10),
          pathname.toUpperCase(),
        );
      } else if (companyId) {
        logPageView(
          'COMPANY',
          Number.parseInt(companyId, 10),
          pathname.toUpperCase(),
        );
      }
    });
  });
</script>
